export default __webpack_public_path__ + "static/media/pic3.b21f297d.jpg";